import { oc } from "@orpc/contract";
import { z } from "zod";

const CompanyValueSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable()
});

const GetCompanyProfileOutputSchema = z.object({
    isOrganizationAdmin: z.boolean(),
    name: z.string().nullable(),
    imageUrl: z.string().nullable(),
    mission: z.string().nullable(),
    values: z.array(CompanyValueSchema).nullable()
});

export type GetCompanyProfileOutput = z.infer<typeof GetCompanyProfileOutputSchema>;

export const companyContract = {
    getCompanyProfile: oc.route({ method: "GET", path: "/get-company-profile" }).output(GetCompanyProfileOutputSchema)
};
